import React, { useContext } from "react";
import { Table } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import FttcHourStore from "../../../app/stores/fttchourStore";

const EmployeeFttcHourList: React.FC = () => {
  const fttchourStore = useContext(FttcHourStore);
  const { fttchournamesByDate, submitting } = fttchourStore;
  return (
    <Table compact size="small" unstackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Financial Year</Table.HeaderCell>
          <Table.HeaderCell>Pay Run</Table.HeaderCell>
          <Table.HeaderCell>Work Order</Table.HeaderCell>
          <Table.HeaderCell>SOR</Table.HeaderCell>
          <Table.HeaderCell>Work Order Lines Description</Table.HeaderCell>
          <Table.HeaderCell>Amount</Table.HeaderCell>
          <Table.HeaderCell>Technician</Table.HeaderCell>
          <Table.HeaderCell>Start Date</Table.HeaderCell>
          <Table.HeaderCell>Comment</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {fttchournamesByDate.map((fttchour) => (
          <Table.Row key={fttchour.id}>
            <Table.Cell>{fttchour.financialYear}</Table.Cell>
            <Table.Cell>{fttchour.payRun}</Table.Cell>
            <Table.Cell>{fttchour.workOrder}</Table.Cell>
            <Table.Cell>{fttchour.sorId}</Table.Cell>
            <Table.Cell>{fttchour.description}</Table.Cell>
            <Table.Cell>{fttchour.amount}</Table.Cell>
            <Table.Cell>{fttchour.tech}</Table.Cell>
            <Table.Cell>
              {fttchour.startDate.substr(8, 2) +
                "/" +
                fttchour.startDate.substr(5, 2) +
                "/" +
                fttchour.startDate.substr(0, 4)}
            </Table.Cell>
            <Table.Cell>{fttchour.comment}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default observer(EmployeeFttcHourList);
